import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function leadNumberCell(visibleColumns: any): any {
  if (!visibleColumns.includes('leadId')) {
    return null;
  }
  return {
    title: () => (
      <TableHeader title={getI18n().t('Lead No', { ns: 'sales' })} sortingDataKey="leadNo" />
    ),
    dataIndex: ['leadId'],
    key: 'leadId',
    render: (leadId: any) => <CellText>{leadId}</CellText>,
    width: 150,
  };
}

export default leadNumberCell;
